import React, { type ComponentProps, type FC } from 'react';
import { CartItems as BaseCartItems } from '@kidslabs/module-quote';
import { CartItemGroup } from '../cart-item-group';
import { useCartGiftSelection } from '@kidslabs/module-flash-sale';

/**
 * CartItemsRenderer for Nova cart (matches mobile Hermes CartItems pattern)
 *
 * Simply wraps BaseCartItems and injects custom CartItemGroupComponent.
 * All other props (onPressItem, onOutOfStockPress, ListHeaderComponent, etc.)
 * are passed through from CartScreen.
 *
 * @see mobile-ecommerce/applications/module-theme-hermes/src/modules/quote/components/cart-items/cart-items.tsx
 */
export const CartItemsRenderer: FC<ComponentProps<typeof BaseCartItems>> = props => {
    const { hasSelectedCartGift, removeAllSelectedGift } = useCartGiftSelection({ createNewSession: false });

    return (
        <BaseCartItems
            {...props}
            CartItemGroupComponent={CartItemGroup}
            hasInvalidLogicRule={hasSelectedCartGift}
            onValidateLogicsBeforeSelect={removeAllSelectedGift}
        />
    );
};
